import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSchemaViewerDateTimeCalcDiscrete = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={17}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#367e9c",
      }}
      d="M17 12v-1.5h-1V13h2v-1z"
    />
    <path
      style={{
        fill: "#367e9c",
      }}
      d="M16.5 9c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5S18.4 9 16.5 9zm0 6c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
    />
    <path
      style={{
        fill: "#367e9c",
      }}
      d="M12 12H8V8h9V5c0-.5-.5-1-1-1h-2V3h-1v1h-2V3h-1v1H8c-.5 0-1 .5-1 1v7c0 .5.5 1 1 1h4v-1zM8 5h2v1h1V5h2v1h1V5h2v2H8V5zM3 9h3v1H3zM3 7h3v1H3z"
    />
  </svg>
);
const Memo = memo(SvgSchemaViewerDateTimeCalcDiscrete);
export default Memo;
